import React, { useEffect, useRef, useState } from "react";
import ChatHeader from "./ChatHeader";
import { useDispatch, useSelector } from "react-redux";
import Conversation from "./Conversation";
import MsgInputBox from "./MsgInputBox";
import { toast } from "react-toastify";
import { sendMessage } from "../../../components/Header/Data";
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useSocket } from "../../../contexts/SocketContext";
import { MessageSeen } from "../../../components/Header/Data2";
import {
  addIncomingMessage,
  setSelectedConversation,
} from "../../../redux/slices/MsgSlice";
import "./Styles/MessagesList.css";
import { fetchMyservices } from "../../../redux/slices/bwvSlice";

const ChatCommunication = ({
  isMobileView,
  onBack,
  toggleDrawer,
  isChatModal,
  isAds,
  homepage,
}) => {
  const dispatch = useDispatch();
  const { sendNewMessage, socket } = useSocket();
  const { loadingConvo, messages, selectedFile, sendingFile, selectedConvo } =
    useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [openModal, setOpenModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const logUser = user?.Role;
  // const logUser = localStorage.getItem("USER_ROLE");
  const { sampleAd } = useSelector((state) => state.searchBar);
  const isFetching = useRef(false);
  const { myServices2 } = useSelector((state) => state.bwvData);
  const handleProfileShare = async () => {
    setOpenModal(false);
    // if no selectedConvo, pass sampleAd.createdBy in customerId and pass sampleAd.Id in postId and sampleAd.createdBy at ownerId and sampleAd.Title at needName
    const messageForm = {
      customerId: selectedConvo
        ? selectedConvo.customerId === user?.UserID
          ? selectedConvo.createdBy
          : selectedConvo.customerId
        : sampleAd.createdBy,
      postId: selectedConvo?.postId ?? sampleAd.Id,
      postType: 1,
      parentId: selectedConvo
        ? selectedConvo.parentId === 0
          ? selectedConvo.Id
          : selectedConvo.parentId
        : 0,
      Description: `My Business Profile, ${user?.UserID}`,
      messageStatus: 8,
      createdBy: user?.UserID,
      roleId: user?.RoleId,
      ownerId: selectedConvo?.ownerId ?? sampleAd.createdBy,
      userName: user?.UserName?.split("@")[0]?.trim() ?? "",
      Email: user?.Email ?? "",
      serviceNeed: "text",
      needName: selectedConvo?.postName ?? sampleAd?.Title ?? "Business Chat",
      clickType: "share",
    };
    const response = await sendMessage(messageForm);
    if (response.Data) {
      let data = response.Data;
      if (data.parentId == 0) {
        dispatch(setSelectedConversation(data));
      }
      sendNewMessage(response.Data);
      dispatch(addIncomingMessage(response.Data));
      toast.success("Business Profile PageLink Sent Successfully");
    }
    setSelectedService(null);
  };
  useEffect(() => {
    fetchServiceData();
  }, [openModal]);
  const fetchServiceData = async () => {
    if (user && !isFetching.current) {
      isFetching.current = true; // Prevent multiple calls
      const serviceParams = {
        pageId: 1,
        pageSize: 20,
        postStatus: 3,
        userId: user?.UserID,
      };
      Promise.all([dispatch(fetchMyservices(serviceParams))]).finally(() => {
        isFetching.current = false; // Reset fetching flag
      });
    }
  };

  if (loadingConvo) {
    return (
      <div className="text-center" style={{ fontSize: "smaller" }}>
        Loading...
      </div>
    );
  }
  return (
    <div
      className="chat-communication tw relative flex flex-col h-full "
      style={{ maxHeight: homepage ? "60vh" : "" }}
    >
      <ChatHeader
        isMobileView={isMobileView}
        onBack={onBack}
        toggleDrawer={toggleDrawer}
        isChatModal={isChatModal}
      />
      <div className="upwork_message flex-grow overflow-y-auto">
        {selectedConvo && selectedConvo.postType === 3 && (
          <div
            className={`${
              selectedConvo && selectedConvo.postType === 3
                ? "visible"
                : "invisible"
            } offer-details-chat`}
          >
            <div
              className="text-center d-flex flex-column align-items-center"
              style={{ fontSize: "smaller" }}
            >
              <span className="text-white px-2 py-1 mb-1 rounded bg-secondary">
                Starting Offer $ {selectedConvo?.Budget}
              </span>{" "}
              <span className="rounded px-2 py-1 bg-success text-white">
                Negotiated $ {selectedConvo?.finalBudget}
              </span>
            </div>
          </div>
        )}
        <div className="message-list-convo">
          {(selectedFile || sendingFile) && (
            <div className="text-center" style={{ fontSize: "smaller" }}>
              Sending Attachment...
            </div>
          )}
          {!loadingConvo &&
            messages &&
            messages.length > 0 &&
            messages.map((msg, index) => (
              <div
                className={`${
                  messages.length === 1
                    ? "single-message"
                    : messages.length === 2
                    ? "two-messages"
                    : ""
                }`}
                key={msg.Id}
              >
                <Conversation
                  key={msg.Id}
                  message={msg}
                  isChatModal={isChatModal}
                />
              </div>
            ))}
        </div>
      </div>
      <div className="message-input-box bg-white sticky bottom-0 w-full">
        <div className="message-input-inner w-full">
          <MsgInputBox isChatModal={isChatModal} isAds={isAds} />
          {logUser === "provider" && (
            <div>
              <p
                className="text-center mb-2 text-primary fst-italic text-decoration-underline"
                onClick={handleProfileShare}
                // onClick={() => setOpenModal(true)}
                style={{ cursor: "pointer" }}
              >
                Send link to visit my Profile Page
              </p>
            </div>
          )}
        </div>
        <Modal isOpen={openModal} toggle={() => setOpenModal(false)}>
          <ModalBody>
            <Label>Choose a Service</Label>
            <Input
              type="select"
              name="activeServices"
              //placeholder="Enter Zip code "
              onChange={(e) => setSelectedService(e.target.value)}
              value={selectedService}
            >
              <option value="" selected>
                Select a Service
              </option>
              {myServices2.map((service) => (
                <option key={service.Id} value={service.Id}>
                  {service.Title}
                </option>
              ))}
            </Input>
            <div className="text-center mt-3">
              <Button onClick={handleProfileShare}>Send Link</Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default ChatCommunication;
